import axios from "axios";
import { baseAPI, notConnectedMessage } from "../components/constants";

export class DescriptionTagsService {
    static url = `${baseAPI}/description-tags`;

    static async createDescriptionTags(data: any) {
        try {
            const response = await axios.post(
                DescriptionTagsService.url + "/create",
                data,
                {
                    withCredentials: true,
                }
            );
            return [response.data, null];
        } catch (err: any) {
            console.log(err);
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }

    static async getDescriptionTags(page = 1, limit = 20, filter = {}) {
        try {
            const response = await axios.get(
                DescriptionTagsService.url + "/get-All",
                {
                    params: { page, limit, ...filter },
                    withCredentials: true,
                }
            );

            return [response.data, null];
        } catch (err: any) {
            console.log(err);
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }

    static async updateDescriptionTags(id: number, data: any) {
        try {
            const response = await axios.patch(
                DescriptionTagsService.url + "/",
                data,
                {
                    params: { id: id },
                    withCredentials: true,
                }
            );

            return [response.data, null];
        } catch (error: any) {
            console.log(error);

            return [
                null,
                error.response?.data?.messaggeg || notConnectedMessage,
            ];
        }
    }

    static async deleteDescriptionTags(id: number) {
        try {
            const response = await axios.delete(DescriptionTagsService.url, {
                params: { id: id },
                withCredentials: true,
            });

            return [response.data, null];
        } catch (err: any) {
            console.log(err);
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }
}
